import { SET_MODELS } from './actionTypes';
import xws from 'api/xws/';
import qs from 'query-string';

// Selectors
import { getWebkey } from 'store/reducers/queryParams/selectors';
import {
  getMakeConfig,
  getVariant
} from 'store/reducers/dealerSettings/selectors';
import { getTokenId } from 'store/reducers/tokenId/selectors';

// Actions
import { ajaxCallbacks } from 'store/reducers/ajaxCall/actions';

// Constants
import { getService } from 'constants/ajax';

export const getModels = year => async (dispatch, getState) => {
  const { make } = getMakeConfig(getState());
  const modelsService = getService('models');
  modelsService.setPathVars({ make });
  modelsService.setCallBacks(dispatch(ajaxCallbacks()));
  const {
    data: { models }
  } = await xws(modelsService).post(
    modelsService.getPath(),
    qs.stringify({
      year,
      ...getState().dealerLocale,
      tokenId: getTokenId(getState()),
      variant: getVariant(getState()),
      webKey: getWebkey(getState()),
      scheduledOnly: 0
    })
  );
  if (models) {
    dispatch(setModels(models));
    return models;
  }
};

export function setModels(models) {
  return {
    type: SET_MODELS,
    payload: models
  };
}



// WEBPACK FOOTER //
// ./src/store/reducers/models/actions.js